import { Typography } from '@mui/material'
import { FC } from 'react'
import { Button, Icons, InformationModal } from 'utoniq-ui'

import { useTranslation } from '@/core'

type RequestPermissionModalProps = {
  open: boolean
  onClose: () => void
}
export const RequestPermissionModal: FC<RequestPermissionModalProps> = ({
  open,
  onClose,
}) => {
  const { t } = useTranslation('gachaDetail')

  return (
    <InformationModal
      open={open}
      onClose={onClose}
      title={
        <>
          <Icons.Spot sx={{ width: 60, height: 60 }} />
          <Typography variant="h5" sx={{ py: 3 }}>
            {t('permissionModalTitle')}
          </Typography>
        </>
      }
      content={t('permissionModalContent')}
      buttons={
        <>
          <Button
            sx={{ minWidth: 212 }}
            variant="text"
            color="primary"
            size="large"
            onClick={onClose}
          >
            {t('close')}
          </Button>
        </>
      }
    />
  )
}
